'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axiosInterceptorsLoader = require('./axios-interceptors-loader');

var _axiosInterceptorsLoader2 = _interopRequireDefault(_axiosInterceptorsLoader);

var _axiosInterceptWixResult = require('./axios-intercept-wix-result');

var _axiosInterceptWixResult2 = _interopRequireDefault(_axiosInterceptWixResult);

var _axiosInterceptBaseurl = require('./axios-intercept-baseurl');

var _axiosInterceptBaseurl2 = _interopRequireDefault(_axiosInterceptBaseurl);

var _axiosInterceptMultilingual = require('./axios-intercept-multilingual');

var _axiosInterceptMultilingual2 = _interopRequireDefault(_axiosInterceptMultilingual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (axios, _ref) {
  var req = _ref.req,
      adapter = _ref.adapter,
      baseURL = _ref.baseURL,
      lang = _ref.lang,
      locale = _ref.locale,
      isPrimaryLanguage = _ref.isPrimaryLanguage,
      siteInstance = _ref.siteInstance,
      _ref$loadInterceptors = _ref.loadInterceptors,
      loadInterceptors = _ref$loadInterceptors === undefined ? true : _ref$loadInterceptors;

  var config = {
    baseURL: baseURL || axios.defaults.baseURL,
    adapter: adapter,
    lang: lang,
    locale: locale,
    isPrimaryLanguage: isPrimaryLanguage,
    siteInstance: siteInstance
  };

  if (req) {
    config.headers = req.headers;
  }

  var instance = axios.create(config);

  instance.unregisterWixInterceptors = _axiosInterceptorsLoader2.default.loadIfNeeded(instance, {
    shouldLoadInterceptors: loadInterceptors,
    interceptors: [_axiosInterceptWixResult2.default, _axiosInterceptBaseurl2.default, _axiosInterceptMultilingual2.default.getInterceptor({ lang: lang, siteInstance: siteInstance, locale: locale, isPrimaryLanguage: isPrimaryLanguage })]
  });

  return instance;
};